var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.12476C7.35957 1.1267 5.78689 1.77922 4.62693 2.93918C3.46697 4.09914 2.81445 5.67183 2.8125 7.31226C2.8125 12.6066 8.4375 16.6056 8.677 16.7731C8.77172 16.8393 8.88447 16.8748 9 16.8748C9.11553 16.8748 9.22828 16.8393 9.323 16.7731C9.5625 16.6056 15.1875 12.6066 15.1875 7.31226C15.1856 5.67183 14.533 4.09914 13.3731 2.93918C12.2131 1.77922 10.6404 1.1267 9 1.12476ZM9.00041 5.06246C9.44542 5.06246 9.88043 5.19442 10.2504 5.44165C10.6205 5.68889 10.9088 6.04029 11.0791 6.45142C11.2494 6.86256 11.294 7.31496 11.2072 7.75141C11.1204 8.18787 10.9061 8.58878 10.5914 8.90345C10.2767 9.21812 9.87582 9.43241 9.43937 9.51923C9.00291 9.60604 8.55051 9.56149 8.13937 9.39119C7.72824 9.22089 7.37684 8.9325 7.12961 8.56249C6.88237 8.19248 6.75041 7.75747 6.75041 7.31246C6.7504 7.01698 6.8086 6.7244 6.92167 6.45141C7.03474 6.17843 7.20047 5.93038 7.4094 5.72145C7.61834 5.51252 7.86638 5.34678 8.13936 5.23371C8.41235 5.12064 8.70494 5.06245 9.00041 5.06246Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapping);
export default __webpack_public_path__ + "static/media/mapping.33658fd5ede10140352cf94262c09f25.svg";
export { ForwardRef as ReactComponent };